import type {
  IControlSettingData,
  IDynamicControlSetting,
} from '~/presentation/reports/common/type';

import {
  EReportChart,
  EDimensionKey,
  EReportControlId,
  IRMetricKey,
} from '~/presentation/reports/common/type';
import { getDimensionSettingUIs, getMetricSettingUIs } from '../utils';
import { DEFAULT_FILTER_PRESET } from './default-filter';

const LIST_METRIC = [IRMetricKey.VISITORS, IRMetricKey.SESSION];
const LIST_DIMENSION = [EDimensionKey.TIME, EDimensionKey.VISITOR];
export const VISITOR_BY_TYPE_PRESET: IControlSettingData = {
  [EReportControlId.METRICS_FILTER]: {
    value: LIST_METRIC,
  },
  [EReportControlId.METRIC]: {
    value: LIST_METRIC[0],
  },
  ...DEFAULT_FILTER_PRESET,
  [EReportControlId.DIMENSIONS_FILTER]: {
    value: LIST_DIMENSION,
  },
  [EReportControlId.CHART]: {
    value: EReportChart.GROUP_BAR,
  },
};

export const VISITOR_BY_TYPE_UI_PRESET: IDynamicControlSetting = {
  [EReportControlId.METRICS_FILTER]: getMetricSettingUIs(LIST_METRIC),
  [EReportControlId.DIMENSIONS_FILTER]: {
    controls: getDimensionSettingUIs(LIST_DIMENSION),
  },
};
